import React from "react";
var __jsx = React.createElement;
import stl from "./carDetailsSection.module.css";
import ProgressiveImage from "@componentsShared/ProgressiveImage";
var SingleCarCC = function SingleCarCC(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: stl.CCContainer,
    "aria-label": props.title,
    id: "car-spec-item-".concat(props.index)
  }, /*#__PURE__*/React.createElement(ProgressiveImage, {
    waitUntilInteractive: true,
    src: props.icon,
    alt: "icon",
    width: 24,
    height: 24,
    loading: "lazy",
    id: "car-spec-icon-".concat(props.index)
  }), /*#__PURE__*/React.createElement("label", {
    id: "car-spec-label-".concat(props.index)
  }, props.title, ":"), /*#__PURE__*/React.createElement("strong", {
    id: "car-spec-value-".concat(props.index)
  }, props.field), props.colorCode && /*#__PURE__*/React.createElement("div", {
    className: stl.colorBox,
    style: {
      backgroundColor: props.colorCode
    },
    id: "car-spec-color-".concat(props.index)
  }));
};
export default SingleCarCC;